import React, {Component} from 'react'
import { connect } from "react-redux"
import { isNullOrWhiteSpace } from '../Services/strings'
import {
    getVehicleDataByRegNo,
    getVehicleDataByVariantId,
    removeVehicle,
    clearState,
} from '../Actions/VehicleFinder.action'

const withVehicleFinder = (WrappedCompnent) => {
    class NewComponent extends Component {
        constructor(props) {
            super(props)
            this._isMounted = false;
            this.state = {
                regNo: '',
                moveOnWithoutVehicle: false,
                loading: false,
            }

            this.removeVehicle = this.removeVehicle.bind(this)
            this.getVehicleDataByRegNo = this.getVehicleDataByRegNo.bind(this)
            this.handleRegNoInputChange = this.handleRegNoInputChange.bind(this)
            this.handleRegNoInputClick = this.handleRegNoInputClick.bind(this)
            this.handleMoveonWithoutVehicleClick = this.handleMoveonWithoutVehicleClick.bind(this)
            this.getVehicleDataByVehicleSelector = this.getVehicleDataByVehicleSelector.bind(this)
            this.handleGoBack = this.handleGoBack.bind(this)
        }

        componentDidMount() {
            this._isMounted = true;
        }

        componentWillUnmount() {
            this._isMounted = false;
        }

        getVehicleDataByRegNo() {
            if (
                !isNullOrWhiteSpace(this.state.regNo) &&
                this.state.regNo.length == 6
            ) {
                this.setState((previousState) => ({
                    ...previousState,
                    loading: true,
                }))
                this.props.getVehicleDataByRegNo(this.state.regNo, () => {
                    if(this._isMounted) {
                        this.setState((previousState) => ({
                            ...previousState,
                            loading: false,
                        }))
                        var element = document.querySelector('.vehicle-finder__links')
                        if (element) {
                            element.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center',
                                inline: 'nearest',
                            })
                        }
                    }
                })
            }
        }

        getVehicleDataByVehicleSelector(selectedVariant) {
            if (!isNullOrWhiteSpace(selectedVariant)) {
                this.setState((previousState) => ({
                    ...previousState,
                    loading: true,
                }))
    
                this.props.getVehicleDataByVariantId(selectedVariant, () => {
                    this.setState((previousState) => ({
                        ...previousState,
                        loading: false,
                    }))
                    var element = document.querySelector('.vehicle-finder__links')
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center',
                            inline: 'nearest',
                        })
                    }
                })
            }
        }

        handleRegNoInputChange(regNo) {
            this.setState((previousState) => ({
                ...previousState,
                regNo: regNo,
            }))
        }
    
        handleRegNoInputClick() {
            this.setState(
                (previousState) => ({
                    ...previousState,
                    moveOnWithoutVehicle: false,
                }),
                () => {
                    this.props.clearState()
                }
            )
        }
    
        handleMoveonWithoutVehicleClick() {
            this.setState(
                (previousState) => ({
                    ...previousState,
                    moveOnWithoutVehicle: true,
                })
            )
        }

        handleGoBack() {
            this.setState({moveOnWithoutVehicle: false})
        }

        removeVehicle() {
            this.props.removeVehicle()
            this.setState((previousState) => ({
                ...previousState,
                regNo: '',
            }))
        }

        render() {
            return <WrappedCompnent 
                {...this.props} 
                {...this.state}
                handleMoveonWithoutVehicleClick={this.handleMoveonWithoutVehicleClick}
                handleRegNoInputChange={this.handleRegNoInputChange}
                handleRegNoInputClick={this.handleRegNoInputClick}
                getVehicleDataByRegNo={this.getVehicleDataByRegNo}
                getVehicleDataByVehicleSelector={this.getVehicleDataByVehicleSelector}
                handleGoBack={this.handleGoBack} />
        }
    }

    const mapStateToProps = ({ vehicleFinder }) => ({
        vehicleFinder,
    })
    
    const mapDispatchToProps = (dispatch) => {
        return {
            removeVehicle: () => dispatch(removeVehicle()),
            getVehicleDataByRegNo: (regNo, callback) =>
                dispatch(getVehicleDataByRegNo(regNo, callback)),
            getVehicleDataByVariantId: (vehicleVariantId, callback) =>
                dispatch(getVehicleDataByVariantId(vehicleVariantId, callback)),
            clearState: () => dispatch(clearState()),
        }
    }

    return connect(
        mapStateToProps,
        mapDispatchToProps
    )(NewComponent)
}



export default withVehicleFinder